import {
  Box,
  MenuItem,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import React, { useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { AxiosResponse } from "axios";
import { Loader } from "../../../../Shared/Common/Loader";
import NoRecord from "../../../../Shared/Common/NoRecord";
import usePagination from "../../../../Shared/hooks/usePagination";
import {
  ArrowDown,
  ArrowUp,
  ExportAllRecords,
  ExportIcon,
  SelectedRecords,
} from "../../../../Shared/Icons";
import { StringRecord } from "../../../../Shared/Type";
import CompendiumPanelMappingRow from "./Row";
import PermissionComponent, {
  AnyPermission,
  getPermissionDisplayName,
} from "Shared/Common/Permissions/PermissionComponent";
import useLang from "Shared/hooks/useLanguage";
import useIsMobile from "Shared/hooks/useIsMobile";
import FacilityService from "Services/FacilityService/FacilityService";
import { ReferenceLab } from "Pages/Blood/BloodCompendium/Panel/Headers";
import { reactSelectSMStyle, styles } from "Utils/Common";
import {
  getAllData,
  PGXCompandiumExportToExcel,
  PGXCompendiumGroupLookup,
  PGXCompGeneLookup,
} from "Services/Compendium/PgxCompendium";
import { StyledDropButton, StyledDropMenu } from "Utils/Style/Dropdownstyle";
import ArrowBottomIcon from "Shared/SVG/ArrowBottomIcon";
import CustomPagination from "Shared/JsxPagination";
export interface SortingTypeI {
  sortingOrder: "asc" | "desc";
  clickedIconData: string | null;
}
export const sortById: SortingTypeI = {
  clickedIconData: "id",
  sortingOrder: "desc",
};
interface IAssayData {
  value: string | number;
  label: string;
  geneCode: string | number;
  performingLabId: string | number;
}
function CompendiumPanelMappingIndex({ refresh }: any) {
  const { t } = useLang();
  const isMobile = useIsMobile();
  const [dropDownValues, setDropDownValues] = useState({
    AssayDataList: [],
    GroupList: [],
  });

  const [searchedTags, setSearchedTags] = useState<string[]>([]);
  const [referenceLab, setReferenceLab] = useState<ReferenceLab[]>([]);
  const [rows, setRows] = useState<any[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [selectedBox, setSelectedBox] = useState<any>({
    ids: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isAddButtonDisabled, setIsAddButtonDisabled] =
    useState<boolean>(false);

  const initialSearchQuery = {
    group: "",
    geneId: 0,
    panelId: 0,
    groupId: 0,
    geneName: "",
    geneCode: "",
    sequence: 0,
    panelCode: "",
    panelName: "",
    panelAbbreviation: "",
    performingLab: "",
    performingLabId: 0,
  };
  const [searchRequest, setSearchRequest] = useState(initialSearchQuery);

  /*#########################----SORT STARTS------########################## */
  const [triggerSearchData, setTriggerSearchData] = useState<boolean>(false);
  const [sort, setSorting] = useState<SortingTypeI>(sortById);
  const searchRef = useRef<any>(null);

  const handleSort = (columnName: any) => {
    searchRef.current.id = searchRef.current.id
      ? searchRef.current.id === "asc"
        ? (searchRef.current.id = "desc")
        : (searchRef.current.id = "asc")
      : (searchRef.current.id = "asc");

    setSorting({
      sortingOrder: searchRef?.current?.id,
      clickedIconData: columnName,
    });

    GetAllCompendiumData();
  };

  /*#########################----SORT ENDS------########################## */
  const queryDisplayTagNames: StringRecord = {
    panelName: "Panel Name",
    panelAbbreviation: "Panel Abbreviation",
    performingLab: "Performing Lab",
    panelCode: "Panel Code",
    geneName: "Gene Name",
    geneCode: "Gene Code",
    group: "Group Name",
    sequence: "Sequence",
  };
  /*##############################-----PAGINATION Start-----#################*/
  const {
    total,
    curPage,
    showPage,
    nextPage,
    prevPage,
    setTotal,
    pageSize,
    totalPages,
    pageNumbers,
    setPageSize,
    setCurPage,
  } = usePagination();

  /*##############################-----Get Api Start-----#################*/
  const GetAllCompendiumData = async (reset: boolean = false) => {
    try {
      setIsLoading(true);
      setIsAddButtonDisabled(true);

      const trimmedSearchRequest = Object.fromEntries(
        Object.entries(searchRequest).map(([key, value]) => {
          if (key === "sequence") {
            if (value === "" || value === null || value === undefined) {
              return [key, 0];
            }
            const sequenceNum = Number(value);
            return [key, Number.isNaN(sequenceNum) ? 0 : sequenceNum];
          }
          return [key, typeof value === "string" ? value.trim() : value];
        })
      );

      const initialQueryModel = {
        pageNumber: curPage,
        pageSize: pageSize,
        sortColumn: sort.clickedIconData || "id",
        sortDirection: sort.sortingOrder || "Desc",
        queryModel: reset ? initialSearchQuery : trimmedSearchRequest,
      };
      const res = await getAllData(initialQueryModel);

      if (res) {
        setRows(res?.data?.result);
        setTotal(res?.data?.totalRecord);
      }
    } catch (error) {
      console.error(
        "An error occurred while fetching Blood Tests setup:",
        error
      );
    } finally {
      setIsLoading(false);
      setIsAddButtonDisabled(false);
    }
  };

  useEffect(() => {
    GetAllCompendiumData();
  }, [curPage, pageSize, triggerSearchData, refresh]);

  const onInputChangeSearch = (e: any) => {
    const { name, value } = e.target;
    if (name === "sequence") {
      if (value === "") {
        setSearchRequest({ ...searchRequest, sequence: 0 });
        return;
      }
      const sequenceNum = parseInt(value, 10);
      setSearchRequest({
        ...searchRequest,
        sequence: Number.isNaN(sequenceNum) ? 0 : sequenceNum,
      });
      return;
    }
    setSearchRequest({ ...searchRequest, [name]: value });
  };

  const onInputSearchLab = (e: any) => {
    setSearchRequest({
      ...searchRequest,
      performingLab: e.label,
      performingLabId: e.value,
    });
  };
  const onInputSearchGene = (e: any) => {
    setSearchRequest({
      ...searchRequest,
      geneName: e.label,
      geneId: e.value,
    });
  };
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      setCurPage(1);
      setTriggerSearchData((prev: any) => !prev);
    }
  };
  const handleChange = (name: string, value: any, id: number) => {
    const normalizedValue =
      name === "sequence"
        ? value === "" || value === null || value === undefined
          ? null
          : Number(value)
        : value;

    setRows((curr: any) =>
      curr.map((x: any) =>
        x.id === id
          ? {
              ...x,
              [name]: normalizedValue,
            }
          : x
      )
    );
  };

  const handleChangePerformingLab = (rowId: number, option: any) => {
    setRows((prevRows) =>
      prevRows.map((r) =>
        r.id === rowId
          ? {
              ...r,
              performingLabId: option?.value,
              geneId: 0,
              geneName: "",
            }
          : r
      )
    );
  };

  const fetchReferenceLab = async () => {
    try {
      const res: AxiosResponse = await FacilityService.referenceLabLookup();
      const referenceArray: ReferenceLab[] =
        res?.data?.data?.map((val: any) => ({
          value: val?.labId,
          label: val?.labDisplayName,
        })) || [];
      setReferenceLab(referenceArray);
    } catch (err: any) {
      console.error("Error fetching reference labs:", err.message);
    }
  };

  const AssayDataLookup = () => {
    PGXCompGeneLookup()
      .then((res: AxiosResponse) => {
        const AssayDataArray: any = [];
        res?.data?.forEach((val: IAssayData) => {
          const AssayDataDetails = {
            value: val?.value,
            label: val?.label,
            geneCode: val?.geneCode,
            performingLabId: val?.performingLabId,
          };
          AssayDataArray.push(AssayDataDetails);
        });
        setDropDownValues((preVal: any) => {
          return {
            ...preVal,
            AssayDataList: AssayDataArray,
          };
        });
      })
      .catch((err: any) => {
        console.trace(err);
      });
  };
  const getFilteredGenes = (labId: number | null) => {
    if (!labId || Number(labId) === 0) return [];

    return dropDownValues.AssayDataList.filter(
      (gene: any) => Number(gene.performingLabId) === Number(labId)
    );
  };

  const GroupLookup = () => {
    PGXCompendiumGroupLookup()
      .then((res: AxiosResponse) => {
        setDropDownValues((preVal: any) => {
          return {
            ...preVal,
            GroupList: res?.data,
          };
        });
      })
      .catch((err: any) => {
        console.trace(err);
      });
  };

  const handleChangeSelectedIds = (checked: boolean, id: number) => {
    setSelectedBox((prev: any) => ({
      ...prev,
      ids: Array.isArray(prev.ids)
        ? checked
          ? [...prev.ids, id]
          : prev.ids.filter((item: number) => item !== id)
        : [id],
    }));
  };

  const handleAllSelect = (checked: boolean, rows: any) => {
    setSelectAll(checked);
    const idsArr: any = [];
    rows.forEach((item: any) => {
      idsArr.push(item?.id);
    });
    if (checked) {
      setSelectedBox((pre: any) => {
        return {
          ...pre,
          ids: idsArr,
        };
      });
    }
    if (!checked) {
      setSelectedBox((pre: any) => {
        return {
          ...pre,
          ids: [],
        };
      });
    }
  };

  const [anchorEl, setAnchorEl] = React.useState({
    dropdown1: null,
    dropdown2: null,
    dropdown3: null,
    dropdown4: null,
  });

  const openDrop =
    Boolean(anchorEl.dropdown1) ||
    Boolean(anchorEl.dropdown2) ||
    Boolean(anchorEl.dropdown3) ||
    Boolean(anchorEl.dropdown4);

  const handleClick = (event: any, dropdownName: any) => {
    setAnchorEl({ ...anchorEl, [dropdownName]: event.currentTarget });
  };

  const handleCloseDropDown = (dropdownName: any) => {
    setAnchorEl({ ...anchorEl, [dropdownName]: null });
  };

  const base64ToExcel = (base64: string, filename: string) => {
    const decodedBase64 = atob(base64);
    const workbook = XLSX.read(decodedBase64, { type: "binary" });
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const excelBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(excelBlob, `${filename}.xlsx`);
  };

  const buildExportPayload = (selectedIds: number[] = []) => {
    const trimmedSearchRequest = Object.fromEntries(
      Object.entries(searchRequest).map(([key, value]) => {
        if (key === "sequence") {
          if (value === "" || value === null || value === undefined) {
            return [key, 0];
          }
          const sequenceNum = Number(value);
          return [key, Number.isNaN(sequenceNum) ? 0 : sequenceNum];
        }
        return [key, typeof value === "string" ? value.trim() : value];
      })
    );

    return {
      pageNumber: 0,
      pageSize: 0,
      sortColumn: sort.clickedIconData || "id",
      sortDirection: sort.sortingOrder || "Desc",
      queryModel: {
        ...trimmedSearchRequest,
        ids: selectedIds.length > 0 ? selectedIds.join(",") : "",
      },
    };
  };

  const downloadAll = () => {
    PGXCompandiumExportToExcel(buildExportPayload()).then(
      (res: AxiosResponse) => {
        if (res?.data?.httpStatusCode === 200) {
          toast.success(res?.data?.message);
          base64ToExcel(res.data.data, "PGX Compendium Data");
          GetAllCompendiumData();
          setSelectAll(false);
          setSelectedBox({ ids: [] });
        } else {
          toast.error(res?.data?.message);
        }
      }
    );
  };

  const downloadSelected = () => {
    if (selectedBox.ids.length > 0) {
      PGXCompandiumExportToExcel(buildExportPayload(selectedBox.ids)).then(
        (res: AxiosResponse) => {
          if (res?.data?.httpStatusCode === 200) {
            toast.success(res?.data?.message);
            base64ToExcel(res.data.data, "PGX Compendium Data");
            GetAllCompendiumData();
            setSelectAll(false);
            setSelectedBox({ ids: [] });
          } else {
            toast.error(res?.data?.message);
          }
        }
      );
    } else {
      toast.error(t("Select atleast one record"));
    }
  };

  const handleChangeAssay = (
    name: string,
    value: string,
    id: number,
    e: any
  ) => {
    setRows((curr) =>
      curr.map((x) =>
        x.id === id
          ? {
              ...x,
              [name]: value,
              geneId: value,
              geneCode: e.geneCode,
            }
          : x
      )
    );
  };

  useEffect(() => {
    AssayDataLookup();
    GroupLookup();
    fetchReferenceLab();
  }, []);

  function handleReset() {
    setSearchRequest(initialSearchQuery);
    setSorting(sortById);
    GetAllCompendiumData(true);
    setPageSize(50);
    setIsAddButtonDisabled(false);
  }

  const handleTagRemoval = (clickedTag: string) => {
    setSearchRequest((searchRequest) => {
      return {
        ...searchRequest,
        [clickedTag]: (initialSearchQuery as any)[clickedTag],
      };
    });
  };

  useEffect(() => {
    const uniqueKeys = new Set<string>();
    for (const [key, value] of Object.entries(searchRequest)) {
      if (value) {
        uniqueKeys.add(key);
      }
    }
    setSearchedTags(Array.from(uniqueKeys));
  }, [searchRequest]);

  useEffect(() => {
    if (searchedTags.length === 0) handleReset();
  }, [searchedTags.length]);

  return (
    <>
      <div className="d-flex gap-4 flex-wrap mb-2">
        {searchedTags.map((tag) =>
          tag === "performingLabId" || tag === "geneId" ? null : (
            <div
              key={tag}
              className="d-flex align-items-center cursor-pointer gap-1 p-2 rounded bg-light"
              onClick={() => handleTagRemoval(tag)}
            >
              <span className="fw-bold">{t(queryDisplayTagNames[tag])}</span>
              <i className="bi bi-x"></i>
            </div>
          )
        )}
      </div>
      <div className="d-flex flex-wrap justify-content-center justify-content-sm-between align-items-center responsive-flexed-actions mb-2 gap-2">
        <div className="d-flex align-items-center responsive-flexed-actions gap-2">
          <div className="d-flex align-items-center">
            <span className="fw-400 mr-3">{t("Records")}</span>
            <select
              id={`PGXCompendiumRecords`}
              className="form-select w-100px h-33px rounded"
              data-allow-clear="true"
              data-dropdown-parent="#kt_menu_63b2e70320b73"
              data-kt-select2="true"
              data-placeholder={t("Select option")}
              value={pageSize}
              onChange={(e) => setPageSize(parseInt(e.target.value))}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
          <div className="d-flex align-items-center gap-2">
            <PermissionComponent
              moduleName="PGX LIS"
              pageName="Compendium Data"
              permissionIdentifier="Add"
            >
              {({ pageName, moduleName, permissionIdentifier }) => (
                <button
                  id={`PGXCompendiumAddNew`}
                  className="btn btn-primary btn-sm btn-primary--icon px-7"
                  disabled={isAddButtonDisabled}
                  onClick={() => {
                    if (!isAddButtonDisabled) {
                      setRows((prevRows: any) => [
                        { rowStatus: true, ...initialSearchQuery },
                        ...prevRows,
                      ]);
                      setIsAddButtonDisabled(true);
                    }
                  }}
                >
                  <i className="fa" style={{ fontSize: 11 }}>
                    
                  </i>
                  <span style={{ fontSize: 11 }}>
                    {getPermissionDisplayName(
                      pageName,
                      moduleName,
                      permissionIdentifier,
                      "Add New"
                    )}
                  </span>
                </button>
              )}
            </PermissionComponent>
            <div>
              <AnyPermission
                moduleName="Requisition"
                pageName="Billing"
                permissionIdentifiers={[
                  "ExportAllRecords",
                  "ExportSelectedRecords",
                ]}
              >
                <StyledDropButton
                  id="BillingRequisitionExportRecord"
                  aria-controls={openDrop ? "demo-positioned-menu2" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openDrop ? "true" : undefined}
                  onClick={(event) => handleClick(event, "dropdown2")}
                  className="btn btn-excle btn-sm"
                >
                  <ExportIcon />
                  <span className="svg-icon svg-icon-5 m-0">
                    <ArrowBottomIcon />
                  </span>
                </StyledDropButton>
                <StyledDropMenu
                  id="BillingRequisitionExportRecordButton"
                  aria-labelledby="demo-positioned-button2"
                  anchorEl={anchorEl.dropdown2}
                  open={Boolean(anchorEl.dropdown2)}
                  onClose={() => handleCloseDropDown("dropdown2")}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <PermissionComponent
                    moduleName="PGX LIS"
                    pageName="Compendium Data"
                    permissionIdentifier="ExportAllRecords"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <MenuItem className=" p-0">
                        <a
                          className=" p-0 text-dark"
                          id="BillingRequisitionExportAllRecord"
                          onClick={() => {
                            handleCloseDropDown("dropdown2");
                            downloadAll();
                          }}
                        >
                          <ExportAllRecords />
                          {getPermissionDisplayName(
                            pageName,
                            moduleName,
                            permissionIdentifier,
                            "Export All Records"
                          )}
                        </a>
                      </MenuItem>
                    )}
                  </PermissionComponent>
                  <PermissionComponent
                    moduleName="PGX LIS"
                    pageName="Compendium Data"
                    permissionIdentifier="ExportSelectedRecords"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <MenuItem className=" p-0">
                        <a
                          className=" p-0 text-dark"
                          id="BillingRequisitionExportSelectedRecord"
                          onClick={() => {
                            handleCloseDropDown("dropdown2");
                            downloadSelected();
                          }}
                        >
                          <SelectedRecords />
                          {getPermissionDisplayName(
                            pageName,
                            moduleName,
                            permissionIdentifier,
                            "Export Selected Records"
                          )}
                        </a>
                      </MenuItem>
                    )}
                  </PermissionComponent>
                </StyledDropMenu>
              </AnyPermission>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center gap-2">
          <button
            id={`PGXCompendiumSearch`}
            className="btn btn-linkedin btn-sm fw-500"
            aria-controls="Search"
            onClick={() => {
              setCurPage(1);
              setTriggerSearchData((prev: any) => !prev);
            }}
          >
            {t("Search")}
          </button>
          <button
            className="btn btn-secondary btn-sm btn-secondary--icon fw-500"
            id={`PGXCompendiumReset`}
            type="button"
            onClick={handleReset}
          >
            <span>{t("Reset")}</span>
          </button>
        </div>
      </div>

      {/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~  Table START ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */}

      <div className="card">
        <Box sx={{ height: "auto", width: "100%" }}>
          <div className="table_bordered overflow-hidden">
            <TableContainer
              sx={
                isMobile
                  ? {}
                  : {
                      maxHeight: "calc(100vh - 100px)",
                      "&::-webkit-scrollbar": {
                        width: 7,
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#fff",
                      },
                      "&:hover": {
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "var(--kt-gray-400)",
                          borderRadius: 2,
                        },
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "var(--kt-gray-400)",
                        borderRadius: 2,
                      },
                    }
              }
              component={Paper}
              className="shadow-none"
            >
              <Table
                aria-label="sticky table collapsible"
                className="table table-cutome-expend table-bordered table-sticky-header table-head-2-bg table-bg table-head-custom table-vertical-center border-0 mb-0"
              >
                <TableHead>
                  <TableRow className="h-40px">
                    <TableCell className="w-50px"></TableCell>
                    <TableCell className="w-50px"></TableCell>
                    <TableCell>
                      <Select
                        inputId="PGXCompendiumCategoryReferanceLab"
                        menuPortalTarget={document.body}
                        theme={(theme) => styles(theme)}
                        options={referenceLab}
                        name="performingLabId"
                        styles={reactSelectSMStyle}
                        placeholder={t("Performing Lab")}
                        value={
                          referenceLab.find(
                            (x) => x.value === searchRequest.performingLabId
                          ) || null
                        }
                        onChange={(e: any) => onInputSearchLab(e)}
                        onKeyDown={handleKeyPress}
                      />
                    </TableCell>
                    <TableCell className="w-300px">
                      <input
                        id={`PGXCompendiumTestName`}
                        type="text"
                        name="panelName"
                        className="form-control bg-white rounded-2 fs-8 h-30px"
                        placeholder={t("Search ....")}
                        value={searchRequest.panelName}
                        onChange={onInputChangeSearch}
                        onKeyDown={(e) => handleKeyPress(e)}
                      />
                    </TableCell>
                    <TableCell className="w-300px">
                      <input
                        id={`PGXCompendiumPanelAbbreviation`}
                        type="text"
                        name="panelAbbreviation"
                        className="form-control bg-white rounded-2 fs-8 h-30px"
                        placeholder={t("Search ....")}
                        value={searchRequest.panelAbbreviation}
                        onChange={onInputChangeSearch}
                        onKeyDown={(e) => handleKeyPress(e)}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        id={`PGXCompendiumTestMethod`}
                        type="text"
                        name="panelCode"
                        className="form-control bg-white rounded-2 fs-8 h-30px"
                        placeholder={t("Search ....")}
                        value={searchRequest.panelCode}
                        onChange={onInputChangeSearch}
                        onKeyDown={(e) => handleKeyPress(e)}
                      />
                    </TableCell>
                    <TableCell>
                      <Select
                        inputId={`IDCompendiumDataPanelMapingAssayDataList`}
                        placeholder={t("Select...")}
                        menuPortalTarget={document.body}
                        styles={reactSelectSMStyle}
                        theme={(theme) => styles(theme)}
                        options={dropDownValues?.AssayDataList}
                        value={
                          dropDownValues?.AssayDataList.find(
                            (x: any) => x.value === searchRequest.geneId
                          ) || null
                        }
                        onChange={(e: any) => onInputSearchGene(e)}
                        onKeyDown={handleKeyPress}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        id={`PGXCompendiumTestCode`}
                        type="text"
                        name="geneCode"
                        className="form-control bg-white rounded-2 fs-8 h-30px"
                        placeholder={t("Search ....")}
                        value={searchRequest.geneCode}
                        onChange={onInputChangeSearch}
                        onKeyDown={(e) => handleKeyPress(e)}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        id={`PGXCompendiumTestCode`}
                        type="text"
                        name="group"
                        className="form-control bg-white rounded-2 fs-8 h-30px"
                        placeholder={t("Search ....")}
                        value={searchRequest.group}
                        onChange={onInputChangeSearch}
                        onKeyDown={(e) => handleKeyPress(e)}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        id={`PGXCompendiumTestCode`}
                        type="number"
                        name="sequence"
                        className="form-control bg-white rounded-2 fs-8 h-30px"
                        placeholder={t("Search ....")}
                        value={searchRequest.sequence || ""}
                        onChange={onInputChangeSearch}
                        onKeyDown={(e) => handleKeyPress(e)}
                      />
                    </TableCell>
                  </TableRow>

                  <TableRow className="h-30px">
                    <TableCell className="w-20px min-w-20px">
                      <label className="form-check form-check-sm form-check-solid d-flex justify-content-center">
                        <input
                          id={`ManageInventoryCheckAll`}
                          className="form-check-input"
                          type="checkbox"
                          onChange={(e: any) =>
                            handleAllSelect(e.target.checked, rows)
                          }
                          checked={selectAll}
                        />
                      </label>
                    </TableCell>
                    <TableCell>{t("Actions")}</TableCell>
                    <TableCell>
                      <div
                        className="d-flex justify-content-between cursor-pointer"
                        onClick={() => handleSort("performingLab")}
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Performing Lab")}
                        </div>

                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${
                              sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "performingLab"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                          <ArrowDown
                            CustomeClass={`${
                              sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "performingLab"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        className="d-flex justify-content-between cursor-pointer"
                        onClick={() => handleSort("panelName")}
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Panel Name")}
                        </div>
                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${
                              sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "panelName"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                          <ArrowDown
                            CustomeClass={`${
                              sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "panelName"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        className="d-flex justify-content-between cursor-pointer"
                        onClick={() => handleSort("panelAbbreviation")}
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Panel Abbreviation")}
                        </div>
                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${
                              sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "panelAbbreviation"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                          <ArrowDown
                            CustomeClass={`${
                              sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "panelAbbreviation"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        className="d-flex justify-content-between cursor-pointer"
                        onClick={() => handleSort("panelCode")}
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Panel Code")}
                        </div>
                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${
                              sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "panelCode"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                          <ArrowDown
                            CustomeClass={`${
                              sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "panelCode"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        className="d-flex justify-content-between cursor-pointer"
                        onClick={() => handleSort("geneName")}
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Gene Name")}
                        </div>
                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${
                              sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "geneName"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                          <ArrowDown
                            CustomeClass={`${
                              sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "geneName"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        className="d-flex justify-content-between cursor-pointer"
                        onClick={() => handleSort("geneCode")}
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Gene Code")}
                        </div>
                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${
                              sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "geneCode"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                          <ArrowDown
                            CustomeClass={`${
                              sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "geneCode"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        className="d-flex justify-content-between cursor-pointer"
                        onClick={() => handleSort("group")}
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Group Name")}
                        </div>
                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${
                              sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "group"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                          <ArrowDown
                            CustomeClass={`${
                              sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "group"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                    <TableCell sx={{ width: "max-content" }}>
                      <div
                        className="d-flex justify-content-between cursor-pointer"
                        onClick={() => handleSort("sequence")}
                        ref={searchRef}
                      >
                        <div style={{ width: "max-content" }}>
                          {t("Sequence")}
                        </div>
                        <div className="d-flex justify-content-center align-items-center mx-4 mr-0">
                          <ArrowUp
                            CustomeClass={`${
                              sort.sortingOrder === "desc" &&
                              sort.clickedIconData === "sequence"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                          <ArrowDown
                            CustomeClass={`${
                              sort.sortingOrder === "asc" &&
                              sort.clickedIconData === "sequence"
                                ? "text-success fs-7"
                                : "text-gray-700 fs-7"
                            } p-0 m-0`}
                          />
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {isLoading ? (
                    <TableCell colSpan={11}>
                      {" "}
                      <Loader />
                    </TableCell>
                  ) : rows?.length ? (
                    rows.map((row: any, index: number) => (
                      <CompendiumPanelMappingRow
                        row={row}
                        rows={rows}
                        index={index}
                        setRows={setRows}
                        selectedBox={selectedBox}
                        referenceLab={referenceLab}
                        handleChange={handleChange}
                        dropDownValues={dropDownValues}
                        key={row.testId ?? `new-${index}`}
                        getFilteredGenes={getFilteredGenes}
                        handleChangeAssay={handleChangeAssay}
                        GetAllCompendiumData={GetAllCompendiumData}
                        setIsAddButtonDisabled={setIsAddButtonDisabled}
                        handleChangeSelectedIds={handleChangeSelectedIds}
                        handleChangePerformingLab={handleChangePerformingLab}
                      />
                    ))
                  ) : (
                    <NoRecord colSpan={11} />
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Box>
      </div>
      {/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~  Table END ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */}

      <CustomPagination
        curPage={curPage}
        nextPage={nextPage}
        pageNumbers={pageNumbers}
        pageSize={pageSize}
        prevPage={prevPage}
        showPage={showPage}
        total={total}
        totalPages={totalPages}
      />
    </>
  );
}

export default CompendiumPanelMappingIndex;
